import { createContext, useContext } from "react";

export interface ILayoutMainContext {
  mainElement: HTMLElement | null;
  headerElement: HTMLElement | null;
  setHeaderElement: (headerElement: HTMLElement | null) => void;
}
export const LayoutMainContext = createContext<ILayoutMainContext>({
  mainElement: null,
  headerElement: null,
  setHeaderElement: (headerElement: HTMLElement | null) => ({}),
});
export const useLayoutMainContext = (): ILayoutMainContext =>
  useContext(LayoutMainContext);
